import { IDataEntryForm } from '../models/data-entry.model';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { ILinkbox } from '../models/linkbox.model';
import { ILinkboxCard } from '../models/linkbox.model';
import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';



export class DynamicHelpers {

  public static clearHiddenFieldValues(formTemplate: IDataEntryForm, formGroup: FormGroup) {
    formTemplate.fields.forEach(kk => {
      if (kk.showFields) {
        if (kk.inputtype == "radiobuttonsshow") {
          kk.options.forEach(option => {
            if (option["option"] == formGroup.value[kk.fieldid] &&
              option["action"] == "hide") {
              //The user may have chosen hide, leaving data in the hidden objects.
              //lets erase any hidden data in the showFields list
              kk.showFields.map(fieldId => {
                formGroup.value[fieldId] = "";
              });
            }
          })
        }

      }

      if (kk.inputtype == "formarray") {
        //remove array members that are empty
        let removeItems: number[] = [];
        let itemList = formGroup.value[kk.fieldid] as string[];
        if (!itemList) { return; }
        itemList.map((item, index) => {
          if (item == null || item == "") {
            removeItems.push(index);
          }
        });
        removeItems.map(myIndex => {
          itemList.splice(myIndex, 1);
        });
      }

    });
  }

  public static findInvalidControls(form: FormGroup) {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  public static getExpireDate(reviewValue) {
    let now = new Date();
    switch (reviewValue) {
      case "3 months": {
        return moment().add(3, 'month')
      }
        break;
      case "6 months": {
        return moment().add(6, 'month')
      }
        break;
      case "12 months": {
        return moment().add(12, 'month')
      }
        break;
      case "18 months": {
        return moment().add(18, 'month')
      }
        break;
      case "24 months": {
        return moment().add(24, 'month')
      }
        break;
    }
  }

  public static async getItemCount(fatherName){
    var http:HttpClient;
    var counter:number=0;
    var zendata = new ZenplansTestDataProviderService();
    let template = await http.get<ILinkbox>("assets/formtemplates/" + fatherName + ".json").toPromise();
    if(template){
      template.cards.map(async card=>{
        counter += await this.getItemCount(card.title); 
      })
    }
    else{
      return await zendata.getSectionItemCount(fatherName);
    }
    return counter;
  }

}
